import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class Text extends React.Component {
  constructor(props) {
    super(props)

    this.config = { 
      types : [ 
        'body',
        'caption'
      ],
      modifiers : [
        "inverse"
      ],
      states : []
    }
  }
  
  render() {
    const { body, caption, inverse, children, ...rest } = this.props
    return <p {...rest} className={resolveProps(this.props, this.config,'Text')}>
      {children}
    </p>
  }
}

Text.propTypes = {
  inverse : PropTypes.bool,
  children : PropTypes.node
}